/* eslint-disable @typescript-eslint/no-magic-numbers */

import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

interface RotateSuggestionProperties {
  children: React.ReactNode;
}

function DetectDevice({ children }: RotateSuggestionProperties) {
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div
        style={{
          position: 'relative',
          filter: isMobile && !isLandscape ? 'blur(5px)' : 'none',
          pointerEvents: isMobile && !isLandscape ? 'none' : 'auto',
        }}
      >
        {children}
      </div>
      {isMobile && !isLandscape && (
        <div
          className="fixed left-0 top-0 z-max flex h-[100%] w-[100%] items-center justify-center"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }}
        >
          <div
            style={{
              padding: '20px 30px',
              borderRadius: '10px',
              textAlign: 'center',
              maxWidth: '80%',
            }}
          >
            <div className="flex flex-col items-center justify-center">
              <img className="mb-2 h-32 w-32" src="./icons/tilt-device.png" alt="tilt" />
              <p className="text-l1 text-white">{t('rotateDevice')}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DetectDevice;
